<p-dialog [styleClass]="'acv_dialog'" [draggable]="false"  [resizable]="false" [closable]="false" [style]="{'width': '31%'}" [modal]="true"
    [visible]="show_Dialog" [appendTo]="appendTo">

    <ng-template pTemplate="header">
        <div class="flex wd-100 dialog_header_wrapper align-items-center justify-content-between ng-star-inserted">
            <span class="text-xl font-bold">{{title}}</span>
            <p-button icon="pi pi-times" (onClick)="hide()"
                styleClass="p-button-rounded p-button-danger p-button-text p-button-raised"></p-button>
        </div>
    </ng-template>

    <div *ngIf="!is_text" class="dialog_content_wrapper">
        <form [formGroup]="rejectForm" *ngIf="rejectForm">
            <div class="grid m-0">
                <div class="col-12">
                    <acv-select
                        class="w-full"
                        ControlLabelText="Reason"
                        [form]="rejectForm"
                        ControlName="reason"
                        [Options]="reasons"
                        OptionLabel="name"
                        OptionValue="id"
                        [Required]="true">
                    </acv-select>
                </div>
                <div class="col-12">
                    <acv-text-input [form]="rejectForm" ControlName="comment" [ControlType]="'text-area'" [ControlLabelText]="'Comment'"
                        [PlaceHolderText]="'Enter Comment'" [characterLimit]="50"
                        [IsSubmited]="is_form_submit" [ShowWordCount]="true"></acv-text-input>
                </div>
            </div>
        </form>
    </div>

    <div *ngIf="is_text" class="dialog_content_wrapper">
            <div class="grid m-0">
                <div class="col-12 md:col-12 lg:col-12 xl:col-12">
                    <p class="fw-500 fs-14 font-poppin mt-4 mb-4 text-content">{{text}}</p>
                </div>
            </div>
    </div>

    <ng-template *ngIf="!is_text" pTemplate="footer">
        <p-button
        *ngIf="!is_text"
        (onClick)="handleCancelConfirm()"
        type="button"
        label="Cancel"
        class="p-button-text elevated-btn secondary mr-2"
      ></p-button>
      <p-button
      *ngIf="!is_text"
        type="button"
        [label]="'Submit'" 
        (onClick)="handleSubmitForm()"
        [loading]="isLoading"
        [disabled]="!rejectForm.controls['reason'].value"
        class="p-button-text elevated-btn primary mr-2"
      ></p-button>
    </ng-template>
</p-dialog>